import { reduce } from 'lodash';

// Translate all of the facility locations to a Google Maps LatLngBounds object.
export const locationsToBounds = (google, facilities) => {
	if (google && facilities.length) {
		return reduce(facilities, (bound, facility) => {
			const facPoint = new google.maps.LatLng(facility.location);
			bound.extend(facPoint);
			return bound;
		}, new google.maps.LatLngBounds());
	}

	return null;
};
